(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8024],{

/***/ 12607:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/category/[slug]",
      function () {
        return __webpack_require__(35939);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 35939:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ DynamicPage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/containers/CollectionD/index.ts + 1 modules
var CollectionD = __webpack_require__(93896);
;// CONCATENATED MODULE: ./src/generated/category/index.tsx




function View(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionD/* CollectionD */.O, (0,_object_spread/* default */.Z)({}, props))
    });
}

// EXTERNAL MODULE: ./src/layouts/BaseLayout/index.tsx + 12 modules
var BaseLayout = __webpack_require__(97691);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(29769);
// EXTERNAL MODULE: ./src/contexts/AppContext/index.tsx + 6 modules
var AppContext = __webpack_require__(13560);
// EXTERNAL MODULE: ./src/utils/localize-helpers.ts
var localize_helpers = __webpack_require__(98751);
// EXTERNAL MODULE: ./src/types/enum.ts
var types_enum = __webpack_require__(95753);
;// CONCATENATED MODULE: ./src/pages/category/[slug].tsx












var __N_SSG = true;
function DynamicPage(props) {
    var ref, ref1, ref2, ref3;
    var title = props.title, collection = props.collection;
    var ref4 = (0,esm/* useTranslation */.$G)([
        "common",
        "category"
    ]), t = ref4.t, i18n = ref4.i18n;
    var appContext = (0,AppContext/* useAppContext */.bp)();
    var ref5 = appContext.useConfig(), name = ref5.name, assetAbsoluteUrl = ref5.assetAbsoluteUrl;
    var router = (0,next_router.useRouter)();
    var paths = (0,localize_helpers/* getLocalizedPaths */.mT)(router);
    var pageContextWithPaths = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props.pageContext), {
        paths: paths
    });
    var seoTitle = i18n.exists("category:title", {
        fallbackLng: props.pageContext.locale
    }) ? t("category:title", {
        title: title
    }) : t("common:title", {
        title: title
    });
    var seoDescription = i18n.exists("category:description", {
        fallbackLng: props.pageContext.locale
    }) ? t("category:description", {
        title: title,
        description: collection.description
    }) : t("common:description", {
        title: title,
        description: collection.description
    });
    var seoContent = "";
    var seoFAQSchema = ";";
    // Customized SEO
    var seo = appContext.useSeo().seo;
    // Categories page
    if (seo === null || seo === void 0 ? void 0 : seo.categories) {
        var ref6;
        var currentPageSEO = (ref6 = seo.categories) === null || ref6 === void 0 ? void 0 : ref6[router.query.slug];
        if (currentPageSEO && router.locale) {
            var seoCurrentLanguage = currentPageSEO === null || currentPageSEO === void 0 ? void 0 : currentPageSEO[router.locale];
            if (seoCurrentLanguage === null || seoCurrentLanguage === void 0 ? void 0 : seoCurrentLanguage.title) {
                seoTitle = seoCurrentLanguage === null || seoCurrentLanguage === void 0 ? void 0 : seoCurrentLanguage.title;
            }
            if (seoCurrentLanguage === null || seoCurrentLanguage === void 0 ? void 0 : seoCurrentLanguage.description) {
                seoDescription = seoCurrentLanguage === null || seoCurrentLanguage === void 0 ? void 0 : seoCurrentLanguage.description;
            }
            if (seoCurrentLanguage === null || seoCurrentLanguage === void 0 ? void 0 : seoCurrentLanguage.h1_description) {
                var ref7;
                if (seoCurrentLanguage === null || seoCurrentLanguage === void 0 ? void 0 : seoCurrentLanguage.show_description) {
                    var ref8;
                    seoContent = ((ref8 = seoCurrentLanguage.h1_description) === null || ref8 === void 0 ? void 0 : ref8.content) || "";
                }
                if (seoCurrentLanguage === null || seoCurrentLanguage === void 0 ? void 0 : (ref7 = seoCurrentLanguage.h1_description) === null || ref7 === void 0 ? void 0 : ref7.seo) {
                    var ref9;
                    seoFAQSchema = JSON.stringify(seoCurrentLanguage === null || seoCurrentLanguage === void 0 ? void 0 : (ref9 = seoCurrentLanguage.h1_description) === null || ref9 === void 0 ? void 0 : ref9.seo) || "";
                }
            }
        }
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(next_seo_module/* NextSeo */.PB, {
                title: seoTitle,
                description: seoDescription,
                openGraph: {
                    images: [
                        {
                            url: "".concat(assetAbsoluteUrl).concat(((ref = collection.games[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.images) === null || ref1 === void 0 ? void 0 : ref1.cover) || ((ref2 = collection.games[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.images) === null || ref3 === void 0 ? void 0 : ref3.cover1x1) || collection.images.cover1x1 || collection.images.cover, "/?ar[r]=1x1&ar[w]=512&fmt=.png"),
                            width: 512,
                            height: 512,
                            alt: "".concat(seoTitle),
                            type: "image/png"
                        }, 
                    ]
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(next_seo_module/* CollectionPageJsonLd */.yr, {
                name: title || seoTitle,
                hasPart: collection.games.map(function(game) {
                    return {
                        about: game.description,
                        author: {
                            name: name
                        },
                        name: game.name,
                        datePublished: game.publishedAt,
                        audience: "Internet",
                        keywords: "schema",
                        thumbnailUrl: "".concat(assetAbsoluteUrl).concat(game.images.cover1x1 || game.images.cover, "/?ar[r]=1x1&ar[w]=512&fmt=.png"),
                        image: "".concat(assetAbsoluteUrl).concat(game.images.cover16x9 || game.images.cover1x1 || game.images.cover, "/")
                    };
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(next_seo_module/* BreadcrumbJsonLd */.gR, {
                itemListElements: pageContextWithPaths.breadcrumbs.map(function(crumb, index) {
                    return {
                        position: index + 1,
                        name: crumb.name,
                        item: crumb.href
                    };
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(View, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                pageContext: pageContextWithPaths
            })),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                dangerouslySetInnerHTML: {
                    __html: seoContent
                },
                style: {
                    padding: "24px"
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
                type: "application/ld+json",
                children: seoFAQSchema
            })
        ]
    });
}
// Adding getLayout property. Allowing us to return a React component for the layout.
// This allows us to define the layout on a per-page basis. Since we're returning a function,
// we can have complex nested layouts if desired.
DynamicPage.getLayout = function getLayout(page) {
    var props = page.props;
    var pageContext = props.pageContext;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BaseLayout/* BaseLayout */.I, {
        pageType: types_enum/* CollectionTypesEnum.CATEGORY */.yU.CATEGORY,
        pageContext: pageContext,
        children: page
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8010,2607,5730,5675,7610,7540,7637,3236,4821,7844,9774,2888,179], function() { return __webpack_exec__(12607); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);